import React, { useContext, useRef, useState } from 'react';

//**************************Componentes Generales******************************************** */
import Card from '../../../../Base/Components/Card/Card';
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';
import CalendarioOperativo from '../../../../Base/Components/CalendarioOperativo/CalendarioOperativo';
import { AuthContext } from '../../../../Base/Context/AuthContext/AuthContext';

///****************************************************Consultas API*************************************************** */
import { getEncabezadosIngresosCombustiblesFechas } from '../../../../API/Inventario/InventarioCombustibles/IngresosCombustibleRequest'
import { Tag } from 'primereact/tag';
import ModalCuentasPorPagarCompras from '../../../../Base/Screens/Proveedores/CuentasPorPagar/ModalCXP/ModalCuentasPorPagarCompras';
import { ConfirmDialog } from 'primereact/confirmdialog';
import Loader from '../../../../Base/Components/Loader/Loader';
import { Checkbox } from 'primereact/checkbox';
import { toastShow } from '../../../../Base/Services/ToastService';
import { Toast } from 'primereact/toast';
import { getDateTimeStringSQL24 } from '../../../../Base/Services/Moment/Luxon';
import { postEstadoFinazasRegistros } from '../../../../Base/API/CuentasPorPagar/CXP/CuentasPorPagarRequest';
import { getDateProduction } from '../../../../Base/Services/FechasService';
const IngresosCombustibleScreen = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState([])
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [dialogFactura, setDialogFactura] = useState(false);
  const [IdFactura, setIdFactura] = useState(null);

  const toast = useRef(null);

  const { userAuth } = useContext(AuthContext);

  const DiasVencidos = (DiasVencidos) => {
    if (DiasVencidos < 0) {
      return (
        <span style={{ color: 'green', justifyContent: 'center', fontWeight: 'bold' }}
          className='text-overFlow text-alingth-center d-flex'>{DiasVencidos}</span>
      )
    } else {
      return (
        <span style={{ color: 'red', justifyContent: 'center', fontWeight: 'bold' }}
          className='text-overFlow text-alingth-center d-flex' >{DiasVencidos}</span>
      )
    }
  }

      const obtenerIngresosFechas = async () => {
          setLoading(true)
          setData([])
  
          if (!dates[0] !== null) {
              if (!dates[1]) {
                  toastShow(toast, 'warn', 'Error', 'Seleccione dos fechas para buscar');
              }
              else {
                  const fechaFormato = getDateProduction(dates)
                  const result = await getEncabezadosIngresosCombustiblesFechas(fechaFormato)
                  setData(result)
              }
  
          } else {
              toastShow(toast, 'error', 'Error', 'Debe de selecionar una fecha.');
          }
          setLoading(false)
  
      }

  const RecibirFactura = async() => {
 
    setLoading(true);
    if (selected.length > 0) {
      let registroValidos = selected.filter((s) => [3713, 3714].includes(s?.IdEstadoFinanzas) === true)
      let registrosSinCAI = selected.filter((s) => s.IdCuenta === 15 && s.IdProveedorCAI === null && s.IdEstadoFinanzas !== 3713)
      if (registrosSinCAI?.length > 0) {
        toastShow(toast, 'error', 'Debe ingresar el CAI de la factura seleccionada')
      } else {
        let datosEnviar = registroValidos?.map((r) => {
          return {
            Id: r?.Id,
            IdEstadoFinanzas: ([3580, 3714].includes(r?.IdEstadoFinanzas)) ? 3713 : 3714,
            IdUserEditCompras: userAuth.idUser,
            FechaEdit: getDateTimeStringSQL24(new Date()),
            IdIngresoReferencia: r.IdIngreso,
            IdReferencia: r.IdReferencia,
            IsRegistroManual: r?.IsRegistroManual,
            FechaRecibidoCompras: ([3580, 3714].includes(r?.IdEstadoFinanzas)) ? getDateTimeStringSQL24(new Date()) : null,
            FechaRevisadoBodega: r.FechaRevisadoBodega

          }
        });

        if (datosEnviar?.length > 0) {
          const result = await postEstadoFinazasRegistros(datosEnviar)
          if (result) {
            if (result[0].ERROR === 0) {
              toastShow(toast, 'success', result[0]?.MSJ)
              obtenerIngresosFechas()
            }
            else {
              toastShow(toast, 'error', result[0]?.MSJ)
            }
          }
        }

      }
    }


    setLoading(false);
  }

  const EstadoTemplate = (rowData) => {
    switch (rowData.IdEstadoFinanzas) {
      case 3581:
        return <Tag style={{ width: 100, backgroundColor: "rgb(0, 191, 57)" }} value={rowData.EstadoFinanzas} />
        break;
      case 3607:
        return <Tag style={{ width: 100, backgroundColor: "rgb(217, 206, 41)" }} value={rowData.EstadoFinanzas} />
        break;
      case 3580:
        return <Tag style={{ width: 100, backgroundColor: "rgb(227, 63, 63)" }} value={rowData.EstadoFinanzas} />
        break;

      default:
        return <div><span>{rowData.EstadoFinanzas}</span></div>
        break;
    }
  }

  const hideDialog = () => {
    setDialogFactura(false)
    setIdFactura(null)
  }

  const table = {
    Data: data,
    selected: selected,
    setSelected: setSelected,
    Columns: [
      {
        field: 'Id',
        header: 'Id',
        headerEn: 'Id',
        className: 'small',
        width: 60,
        hidden: userAuth.IdRol === 1,
        frozen: true,
        alignFrozen: 'left'
      },
      {
        field: 'IncomeDate',
        header: 'Fecha Ingreso',
        headerEn: 'Income Date',
        className: 'small',
        Format: 'Date',
        Frozen: true,
        alignFrozen: 'left'
      },
      {
        field: 'NoIngreso',
        header: 'No Ingreso',
        headerEn: 'No. Income',
        className: 'small',
        Format: 'Center',
        Sumary: 'count',
        Frozen: true,
        alignFrozen: 'left',
        onCellDoubleClicked: ({ data }) => {
          if (data?.Id > 0) {
            setIdFactura(data?.Id)
            setDialogFactura(true)
          }
        }
      },
      {
        field: 'EstadoFinanzas',
        header: 'Estado Finazas',
        headerEn: 'Finance Status',
        className: 'small',
        Format: 'Template',
        body: (rowData) => EstadoTemplate(rowData),
      },
      {
        field: 'Documento',
        header: 'Factura',
        headerEn: 'Invoice',
        className: 'medium',
        onCellDoubleClicked: ({ data }) => {
          if (data.Id > 0) {
            setIdFactura(data?.Id)
            setDialogFactura(true)
          }
        }
      },
      {
        field: 'CustomerName',
        header: 'Proveedor',
        headerEn: 'Supplier',
        className: 'large',
      },
      {
        field: 'OCE',
        header: 'OCE',
        headerEn: 'OCE',
        className: 'small',
        Format: 'Center'
      },
      {
        field: 'FechaDocumento',
        header: 'Fecha Factura',
        headerEn: 'Invoice Date',
        className: 'small',
        Format: 'Date',
      },
      {
        field: 'PurchaseOrder',
        header: 'Orden Compra',
        headerEn: 'Purchase Order',
        className: 'small',
        Format: 'Center',
        onCellDoubleClicked: ({ data }) => {
          if (data.PurchaseOrder) {
          }
        }
      },
      {
        field: 'TermName',
        header: 'Terminos',
        headerEn: 'Terms',
        className: 'small',
        Format: 'Center'
      },
      {
        field: 'FechaVencido',
        header: 'Fecha Vencido',
        headerEn: 'Expired Date',
        className: 'small',
        Format: 'Date',
      },
      {
        field: 'DiasVencidos',
        header: 'Dias Vencidos',
        headerEn: 'Expired Days',
        className: 'Xsmall',
        Format: 'Template',
        body: rowData => DiasVencidos(rowData.DiasVencidos)
      },
      {
          field: 'IdEstadoFinanzas',
          header: 'IdEstadoFinanzas',
          headerEn: '',
          className: '',
      },
      
      {
        field: 'Id',
        header: 'Recibido ',
        headerEn: 'Recibido',
        className: 'Xsmall',
        Format: 'Template',
        frozen: true,
        alignFrozen: 'right',
        body: (data) => data.Id ? (
          <div onClick={() => { if (selected.length === 0) setSelected([data]) }}
            // onDoubleClick={() => { if ([3713, 3714, 3580].includes(data?.IdEstadoFinanzas)) RecibirFactura() }} 
            className='d-flex flex-row' style={{ justifyContent: 'center' }}>
            <Checkbox checked={[3581, 3607, 3713].includes(data?.IdEstadoFinanzas)} disabled={true} />
          </div>
        ) : null,
        hidden: [1, 8].includes(userAuth.IdRol),
      },
      {
        field: 'MontoL',
        header: 'Monto L',
        headerEn: 'Amount L',
        className: 'small',
        Format: 'Currency',
        Sumary: 'sum',
        Frozen: true,
        alignFrozen: 'right'
      },
      {
        field: 'MontoD',
        header: 'Monto $',
        headerEn: 'Amount $',
        className: 'small',
        Format: 'Currency',
        Sumary: 'sum',
        Frozen: true,
        alignFrozen: 'right'
      },
    ]
  }
  return (
    <div>
      <ConfirmDialog />
      <Toast ref={toast} />
      <Loader loading={loading} querySelector={'#IngresosCombustibles'} />
      <Card
        titulo={<CalendarioOperativo
          getInfo={getEncabezadosIngresosCombustiblesFechas}
          data={data}
          setData={setData}
          Nombre='Ingresos Combustible'
          selected={selected}
          setSelected={setSelected}
          dates={dates}
          setDates={setDates}
          type='Month'
          loading={loading}
          setLoading={setLoading}

        />}
        contenido={<div className='pt-4' style={{ height: '90vh' }} id='IngresosCombustibles'>
          <AgGrid table={table} />
        </div>}
      />
      <ModalCuentasPorPagarCompras
        dialogCuentas={dialogFactura}
        IdFactura={IdFactura}
        hideDialog={hideDialog}
      />
    </div>
  )
}

export default IngresosCombustibleScreen
